import { default as clickToRead } from "./click-to-read.json";
import { default as connectApp } from "./connect-app.json";
import { default as externalLink } from "./external-link.json";
import { default as internalClickToRead } from "./internal-click-to-read.json";
import { default as medicationEnrollment } from "./medication-enrollment.json";
import { default as offersError } from "./offers-error.json";
import { default as offersList } from "./offers.json";
import { default as oneClick } from "./one-click.json";
import { default as programEnrollment } from "./program-enrollment.json";
import { default as referral } from "./referral.json";
import { default as survey } from "./survey.json";
import { default as surveymonkeySurvey } from "./surveymonkey-survey.json";

const data: { [key: string]: object } = {
  "default": offersList,
  "error": offersError,
  "click-to-read": clickToRead,
  "connect-app": connectApp,
  "external-link": externalLink,
  "internal-click-to-read": internalClickToRead,
  "medication-enrollment": medicationEnrollment,
  "one-click": oneClick,
  "program-enrollment": programEnrollment,
  "referral": referral,
  "survey": survey,
  "surveymonkey-survey": surveymonkeySurvey,
};

const offers = {
  get: () => data["default"],
  getOne: (offerIdentifier: string) => {
    if (!data[offerIdentifier]) {
      throw new Error(
        `Unable to find the provided offer identifier: ${offerIdentifier}`
      );
    }

    return data[offerIdentifier];
  },
};

export default offers;
